var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.666,
    height: 13.666,
    viewBox: "0 0 13.666 13.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.825,13.5,3,15.325,4.825,17.15",
    transform: "translate(-3 -9.242)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.5,4.825,15.325,3,17.15,4.825",
    transform: "translate(-9.242 -3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.15,28.5l-1.825,1.825L13.5,28.5",
    transform: "translate(-9.242 -18.159)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.5,13.5l1.825,1.825L28.5,17.15",
    transform: "translate(-18.159 -9.242)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3,18H15.166",
    transform: "translate(-3 -11.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18,3V15.166",
    transform: "translate(-11.917 -3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.556bc7f2ba20dec234f293a9c2b81629.svg";
export { ForwardRef as ReactComponent };